import { differenceInDays } from 'date-fns';

export function trueDaysDiff(date: Date) {
  const today = new Date();

  // setting hours to zero is important for correct date comparison. This is the reason why date-fns methods isFuture/isPast don't work for this case.
  today.setHours(0, 0, 0, 0);
  const daysDiff = differenceInDays(date, today);
  const daysDiffAbs = Math.abs(daysDiff);
  const daysDiffAbsStr = `${daysDiffAbs} ${daysDiffAbs === 1 ? 'day' : 'days'}`;

  return { daysDiff, daysDiffAbsStr };
}
